
<div class="container" style="width: 95%;" *ngIf="lgvCompanySvc.activeCompany$ | async as company" class="Lgv_{{company.companyCode}}">
    <div class="row">
        <div class="col-md-12 modal-title" style="height: 0px;">
            <button  class="close" mat-button (click)="onNoClick()">X</button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 modal-title" style="font-size: 18px;padding-bottom: 10px;">
            <span><fa-icon icon="user-cog" title=""></fa-icon></span>&nbsp;&nbsp;
            <span class="font-weight-bold">{{data.clientFirstName}} {{data.clientLastName}}</span>
           
        </div>
    </div>
    <div class="row">
        <div class="col-lg-3 col-md-2">Date:</div>
        <div class="col-lg-9 col-md-10">
            <p>{{data.latestActivityTimestamp  | date: 'short'}}</p>
           
        </div>
    </div>
    <div class="row">
        <div class="col-lg-3 col-md-2">Activity:</div>
        <div class="col-lg-9 col-md-10" style="max-height: 650px; overflow-y: auto;">
         
            <!-- <mat-list> -->
                <ng-container *ngFor="let x of data.activities">
                    <!-- <mat-list-item *ngIf="x.isHot" > -->
                        <p *ngIf="x.isRelevant" class="font-weight-bold"><img class="float-left"  src="./assets/images/icons/flame-icon_{{company.companyCode}}.svg" style="height:20px;padding-right: 5px;"/>
                        {{x.activityName}} ({{x.count}})</p>
                    <!-- </mat-list-item> -->
                        <p  *ngIf="!x.isRelevant">{{x.activityName}}  ({{x.count}})</p>
                    <!-- <mat-list-item *ngIf="!x.isHot" >{{x.activityName}}  ({{x.count}})</mat-list-item> -->
                </ng-container>
            <!-- </mat-list> -->
        </div>
    </div>
   
</div>
